<template>
    <Transition name="jump" :appear="appear" @before-enter="handleEnterDelay" @leave="handleLeaveDelay" @after-enter="$emit('after-enter', $event)">
        <slot></slot>
    </Transition>
</template>

<script>
export default {
    name: 'jump-transition',
    data() {
        return {
            staggerDelay: 25
        }
    },
    props: {
        stagger: {
            type: Boolean,
            default: false
        },
        appear: {
            type: Boolean,
            default: true
        },
        jump: {
            type: String,
            default: 'medium'
        }
    },
    methods: {
        handleEnterDelay(element) {
            if(!this.stagger) return element.style = `--delay: 0ms`;

            const transitions = document.querySelectorAll('.jump-stagger');
            const index = transitions.length;
            const delay = index * this.staggerDelay;

            let style = '';
            
            style += `--delay: ${delay}ms;`;
            if(this.jump === 'big') style += `animation-timing-function: cubic-bezier(.51,2,.45,1.08);`;

            element.style = style;
        },
        handleLeaveDelay(element) {
            if(!this.stagger) return element.style = `--delay: 0ms`;

            const transitions = [ ...document.querySelectorAll('.jump-stagger') ];
            const index = transitions.findIndex(transition => transition.contains(element));
            const delay = (transitions.length - index) * this.staggerDelay;
            
            element.style = `--delay: ${delay}ms`;
        }
    },
}
</script>

<style lang="scss" scoped>

.jump-enter-active {
    opacity: 0;
    scale: 0.5;
    animation: jumpIn .25s cubic-bezier(.51,1.4,.45,1.08) forwards var(--delay, 0ms);
}
.jump-leave-active {
    scale: 1;
    opacity: 1;
    animation: jumpOut .15s ease-in forwards var(--delay, 0ms);
}

@keyframes jumpIn {
    from {
        opacity: 0;
        scale: 0.5;
    } to {
        opacity: 1;
        scale: 1;
    }
}
@keyframes jumpOut {
    0% {
        scale: 1;
        opacity: 1;
    } 100% {
        opacity: 0;
        scale: 0.2;
    }
}
    
</style>